import { render, staticRenderFns } from "./ContentsFormComponent.vue?vue&type=template&id=0f2ba23f&scoped=true&"
import script from "./ContentsFormComponent.vue?vue&type=script&lang=js&"
export * from "./ContentsFormComponent.vue?vue&type=script&lang=js&"
import style0 from "./ContentsFormComponent.vue?vue&type=style&index=0&id=0f2ba23f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f2ba23f",
  null
  
)

export default component.exports